var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"active":_vm.queryLoading,"background-opacity":0.3,"height":2,"indeterminate":true,"stream":true,"value":100,"color":"primary"}}),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.items.averageRating)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.items.totalCount)+" calls ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }